import * as constants from './constants';
import Config from '@/config';
import { $catch, $public } from '@/utils';
import appApi from '@/api/app';
import {getUserRoute} from "../../../store/app/action";


const changeLogin = (status) => {
    return {
        type: constants.LOGIN_DATA,
        login: status
    };
};


//登录
export const getLogin = (data, oauth_type) => {
    return (dispatch) => {
        appApi.login(data, oauth_type)
            .then(res => {
                if(res?.token){
                    //登录成功
                    $catch.setSessionItem(Config.headers[0], res.token);
                    dispatch(getUserRoute());//获取菜单信息
                    setTimeout(()=>{
                        dispatch(changeLogin(true));  //进入系统
                    },500)
                }else {
                    $public.err(res.message || '系统错误');
                }
            })
    };
};


//获取图片验证码
export const getValidCode = (data) => {
    return (dispatch) => {
        appApi.getPictrueCode(data)
            .then(res => {
                if(res && !data){
                    dispatch({
                        type: constants.PICTRUE_CODE,
                        value: res  // {img: '', uuid: ''}
                    });
                }
            })
    };
};

